function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { View } from 'react-native';
import { HelperText } from 'react-native-paper';
export const Container = (_ref) => {
  let {
    children,
    HelperTextProps
  } = _ref,
      ContainerProps = _objectWithoutProperties(_ref, ["children", "HelperTextProps"]);

  return /*#__PURE__*/React.createElement(View, ContainerProps, children, !!HelperTextProps.visible && /*#__PURE__*/React.createElement(HelperText, HelperTextProps));
};
Container.displayName = 'Container';